<template>
    <b-overlay opacity="0.75" spinner-variant="primary" :show="$root.$data.bsLoader">
        <!-- my code -->
        <div class="edit-user-profile">
            <!-- navbar -->
            <nav-bar/>
            <div class="user-settings">
                <!-- profile bar -->
                <div class="change-details">
                    <profile-bar> </profile-bar>
                </div>

                <!-- form -->
                <div class="user-form">
                    <a href="#!" class="menu" @click="opensidebar()"><i class="fas fa-bars fa-2x"></i></a>
                    <div class="user-form-box p-4">
                        <div class="card-body">
                            <!-- <b-alert show variant="success" v-if="successMessage">{{successMessage}}</b-alert> -->
                            <h1 class="font-weight-bold text-center">Update Password</h1>
                                <b-form @submit.prevent="passwordFormSubmitted" @keydown="form.onKeydown($event)" class="mt-5">
                                    <b-form-group>
                                        <template v-slot:label>
                                            Current Password <span class="text-danger">*</span>
                                        </template>
                                        <b-form-input
                                            type="password"
                                            placeholder="Enter your old password"
                                            v-model="form.password"
                                            v-bind:class="{
                                            'is-invalid': form.errors.has('password'),
                                            }"
                                        ></b-form-input>
                                        <has-error :form="form" field="password"></has-error>
                                    </b-form-group>

                                    <b-form-group>
                                        <template v-slot:label>
                                            New Password <span class="text-danger">*</span>
                                        </template>
                                        <b-form-input
                                            type="password"
                                            placeholder="Enter a new password"
                                            v-model="form.new_password"
                                            v-bind:class="{
                                            'is-invalid': form.errors.has('new_password'),
                                            }"
                                        ></b-form-input>
                                        <has-error :form="form" field="new_password"></has-error>
                                    </b-form-group>

                                    <b-form-group>
                                        <template v-slot:label>
                                            Re-enter Password <span class="text-danger">*</span>
                                        </template>
                                        <b-form-input
                                            type="password"
                                            placeholder="Re-enter a new password"
                                            v-model="form.confirm_password"
                                            v-bind:class="{
                                            'is-invalid': form.errors.has('confirm_password'),
                                            }"
                                        ></b-form-input>
                                        <has-error :form="form" field="confirm_password"></has-error>
                                    </b-form-group>
                                    <b-button :disabled="form.busy" type="submit" variant="primary" class="btn-grad float-right">Update</b-button>
                                </b-form>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <!-- my code ends -->
    </b-overlay>
</template>

<script>
import NavBar from "../includes/NavBar.vue";
import {Form, HasError} from "vform";
import ProfileBar from "../includes/ProfileBar.vue";
import toggleMixin from "../../../../mixins/toggleMixin.js";
import axios from 'axios';
import Swal from "sweetalert2";

export default {
    components :
    {
        ProfileBar,NavBar,
    },

      mixins: [toggleMixin],

     data() {
        return {
            form: new Form({
                password: '',
                new_password: '',
                confirm_password: ''
            }),
            // successMessage: "",
        }
    },

    methods :
    {
        passwordFormSubmitted() {
            this.$root.$data.bsLoader = true;
            this.form.post("api/manager/updatePassword").then(() => {
                // this.successMessage = "Password Updated Successfully."
                this.form.password = '';
                this.form.new_password = '';
                this.form.confirm_password = '';

                Swal.fire({
                    title: "Password Updated Successfully.",
                    icon: "success",
                    timer: 3000,
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                });

                this.$root.$data.bsLoader = false;
            }).catch((err) => {
                this.$root.$data.bsLoader = false;
            });
        },
        opensidebar(){
            let sidebarDetails = document.querySelector('.change-details');
            this.toggleProfile(sidebarDetails)
        }
    },
}
</script>
